import { Permission } from './permission';

export class ControlMenu {
    Id: number;
    Name: string;
    ParentId: number;
    Permissions: Permission[];
    IsVisible: boolean = true;

    constructor(id: number, name: string, parentId: number, permissions: Permission[], isVisible: boolean = true) {
        this.Id = id;
        this.Name = name;
        this.ParentId = parentId;
        this.Permissions = permissions;
        this.IsVisible = isVisible;
    }
}
